export default __webpack_public_path__ + "static/RE_logo_positive-78d87493a9139ba8b5dfce3e50347566.svg";